import { render, staticRenderFns } from "./gasClamp_towerPower.vue?vue&type=template&id=12bf58f8&scoped=true"
import script from "./gasClamp_towerPower.vue?vue&type=script&lang=js"
export * from "./gasClamp_towerPower.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_towerPower.vue?vue&type=style&index=0&id=12bf58f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf58f8",
  null
  
)

export default component.exports